import { render, staticRenderFns } from "./MobileMenu.vue?vue&type=template&id=3fdd9ace"
import script from "./MobileMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileMenu.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MobileMenu.vue?vue&type=style&index=0&id=3fdd9ace&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports